<!--<div class="row p-1">
    <div class="col-12 pageTitle">
        <h2>&nbsp;&nbsp;&nbsp;Report ({{title}}) Parameter Details</h2>
    </div>
</div>-->

<div class="card pt-0">
  <div class="">
    <div class="col-12 pl-3 bold">
      {{ title }}
    </div>
  </div>
  <hr />
  <div
    class="p-fluid formgrid grid"
    *ngFor="let item of reportParamDto?.reportParamList"
  >
    <div class="col-12 md:col-12" [ngSwitch]="stringToNumber(item.datatype)">
      <div class="field col-12 md:col-6" *ngSwitchCase="item.isrequired"></div>

      <!-- NUMBER -->
      <div
        class="field col-12 md:col-12"
        *ngSwitchCase="dropDownDataType.number"
      >
        <span class="p-float-label">
          <input
            id="float-minn"
            type="number"
            pInputText
            [(ngModel)]="item.value"
            autocomplete="off"
          />
          <label for="float-minn">{{ item.reportparamshortnote }}</label>
        </span>
      </div>

      <!-- STRING -->
      <div
        class="field col-12 md:col-12"
        *ngSwitchCase="dropDownDataType.string"
      >
        <span class="p-float-label" *ngIf="!item.picklistValues">
          <input
            id="float-maxstr"
            type="text"
            pInputText
            [(ngModel)]="item.value"
            autocomplete="off"
          />
          <label for="float-maxstr">{{ item.reportparamshortnote }}</label>
        </span>

        <!--<span class="p-float-label" *ngIf="item.picklistValues">
                <select [ngModel]="item.value" (ngModelChange)="item.value = $event" class="form-control">
                    <option *ngFor="let option of item.picklistValues.split(';')" [value]="option">{{ option }}</option>
                </select>
            </span>-->
      </div>

      <!-- DATE -->
      <div class="field col-12 md:col-12" *ngSwitchCase="dropDownDataType.date">
        <span class="p-float-label">
          <!--<input id="float-begindte" type="text" pInputText [(ngModel)]="item.value" autocomplete="off" class="textboxBorder-0">-->

          <p-calendar
            id="float-begindte"
            [(ngModel)]="item.value"
            [yearNavigator]="true"
            yearRange="{{ yearRangeForDatePicker }}"
            [readonlyInput]="true"
            showButtonBar="true"
            class="p-0"
            appendTo="body"
          ></p-calendar>

          <label for="float-begindte">{{ item.reportparamshortnote }}</label>
        </span>
      </div>

      <!-- DATETIME -->
      <div
        class="field col-12 md:col-12"
        *ngSwitchCase="dropDownDataType.dateTime"
      >
        <span class="p-float-label">
          <!--<input id="float-strtdt" type="text" pInputText [(ngModel)]="item.value" autocomplete="off" class="textboxBorder-0">-->

          <p-calendar
            id="float-begindte"
            [(ngModel)]="item.value"
            [yearNavigator]="true"
            yearRange="{{ yearRangeForDatePicker }}"
            [readonlyInput]="true"
            showButtonBar="true"
            class="p-0"
            appendTo="body"
          ></p-calendar>

          <label for="float-strtdt">{{ item.reportparamshortnote }}</label>
        </span>
      </div>

      <!-- TIME -->
      <div class="field col-12 md:col-12" *ngSwitchCase="dropDownDataType.time">
        <span class="p-float-label">
          <!--<input id="float-begindte" type="text" pInputText [(ngModel)]="item.value" autocomplete="off" class="textboxBorder-0">-->
          <p-calendar
            id="float-begindte"
            [(ngModel)]="item.value"
            [yearNavigator]="true"
            [timeOnly]="true"
            [readonlyInput]="true"
            [showButtonBar]="false"
            class="p-0"
            appendTo="body"
          ></p-calendar>

          <label for="float-begindte">{{ item.reportparamshortnote }}</label>
        </span>
      </div>

      <!-- BOOLEAN -->
      <div
        class="field col-12 md:col-12"
        *ngSwitchCase="dropDownDataType.boolean"
      >
        <span class="ui-float-label">
          <!--<input id="float-begindte" type="checkbox" [(ngModel)]="item.value" autocomplete="off">
                    <label for="float-begindte">{{item.reportparamshortnote}}</label>-->

          <p-checkbox
            name="boolean"
            label="{{ item.reportparamshortnote }}"
            [(ngModel)]="item.value"
            autocomplete="off"
            binary="true"
          ></p-checkbox>
        </span>
      </div>

      <!-- CURRENCY -->
      <div
        class="field col-12 md:col-12"
        *ngSwitchCase="dropDownDataType.currency"
      >
        <span class="p-float-label">
          <input
            id="float-mincurrr"
            type="number"
            pInputText
            [(ngModel)]="item.value"
            autocomplete="off"
          />
          <label for="float-mincurrr">{{ item.reportparamshortnote }}</label>
        </span>
      </div>
    </div>
  </div>

  <div class="field col-1 md:col-1">
    <button
      pButton
      type="button"
      icon="pi pi-save"
      label="Load Report"
      class="ui-button-success"
      (click)="loadReport()"
    ></button>
  </div>
</div>
